import { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MasajidContext } from "../contexts/MasajidContext";

function InitialRedirect({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { getMyMasjid } = useContext(MasajidContext);

  useEffect(() => {
    // Only redirect on initial app load (when on home page)
    const isInitialLoad = location.pathname === "/" && !sessionStorage.getItem("hasNavigated");

    if (isInitialLoad) {
      const myMasjidUsername = getMyMasjid();
      if (myMasjidUsername) {
        sessionStorage.setItem("hasNavigated", "true");
        navigate(`/masjid/${myMasjidUsername}`, { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
}

export default InitialRedirect;
